export default __webpack_public_path__ + "static/media/text-signup.189320cf.svg";